<template>
  <v-container 
    id="blog"
    fluid grey darken-3 
    class="my-0 py-12"
  >
    <v-row
      class="pt-12"
    >
      <v-col
        cols="12"
        class="text-center"
      >
        <h2 class="display-1 font-weight-bold pt-0">
          <span class="barlow primary--text">DESTAQUES DO BLOG</span>
        </h2>
      </v-col>
    </v-row>
    <v-row
      class="pb-12 px-12"
    >
      <v-col
        v-for="(p,i) in posts"
        :key="i"
        cols="12"
        md="4"
      >
        <v-card tile flat hover
          class="pb-4 fill-height white grey--text text--darken-4 text-center" 
          nuxt
          :href="p.url"
          target="_blank"
        >
          <v-img
            class=""
            height=""
            :src="getImg(p.imagem)"
          >
          </v-img>
          <v-card-subtitle class="pb-0 caption text-uppercase">
            <span class="font-weight-medium grey--text text--darken-2">
              {{p.categoria}}
            </span>
          </v-card-subtitle>
          <v-card-title class="pt-2 headline justify-center">
            <span class="font-weight-bold">{{p.titulo}}</span>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      class="pb-12"
    >
      <v-col
        cols="12"
        class="text-center"
      >
        <v-btn
          x-large outlined
          color="primary"
          class="font-weight-bold"
          href="https://institutoaltoimpacto.com.br/blog"
        >Ver todos</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    posts: [
      {
        imagem: 'sombra1-700x840.jpg',
        url: 'https://institutoaltoimpacto.com.br/blog/posts/o-efeito-sombra-no-processo-de-mudanca',
        categoria: 'Desenvolvimento Pessoal',
        titulo: 'O Efeito Sombra no Processo de Mudança'
      },
      {
        imagem: 'metas1-700x840.jpg',
        url: 'https://institutoaltoimpacto.com.br/blog/posts/metas-e-objetivos-como-assumir-o-controle-da-sua-vida',
        categoria: 'Desenvolvimento Pessoal',
        titulo: 'Metas e Objetivos: Como Assumir o Controle da Sua Vida'
      },
      {
        imagem: 'mudancas1-700x840.jpg',
        url: 'https://institutoaltoimpacto.com.br/blog/posts/como-crescer-e-prosperar-com-as-mudancas',
        categoria: 'Desenvolvimento Pessoal',
        titulo: 'Como Crescer e Prosperar com as Mudanças?'
      },
    ],
  }),
  methods: {
    getImg(i) {
      return require('@/assets/img/blog/'+i)
    },
  },
}
</script>